import React from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { Fragment } from "react";
import { toast } from "react-toastify";
import { confirmDialog } from "primereact/confirmdialog";
import { leaveService } from "../../../../services/extensions";
import { MultiSelect } from "primereact/multiselect";
import { Dialog } from "primereact/dialog";
import { Chip } from "primereact/chip";

const UserLeaveDialog = ({ onClose, clickedUserData }) => {
  const [userLeaveData, setUserLeaveData] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [dlgNewLeave, setDlgNewLeave] = useState(false);
  // const [editingRowId, setEditingRowId] = useState(null);
  const dt = useRef(null);

  useEffect(() => {
    getUserLeaves();
  }, []);

  const onCloseMethod = () => {
    onClose();
  };

  const getUserLeaves = () => {
    try {
      leaveService.getLeavesByUser(clickedUserData.id).then((resp) => {
        setUserLeaveData(resp.data.data);
        getAbsenceCodes(resp.data.data);
      });
    } catch (error) {
      //error
    }
  };

  const getAbsenceCodes = (usrLeaves) => {
    leaveService.getAbsenceCodesByUserLocation().then((resp) => {
      let absCode = [];
      const ul = usrLeaves.map((x) => x.code) || [];
      resp.data.data.map((el) => {
        if (!ul.includes(el.code)) {
          const obj = {
            ...el,
            label: (
              <span className="ess-list-item">
                <strong>{el.code}</strong> ({el.title})
              </span>
            ),
          };
          absCode.push(obj);
        }
      });
      setLeaveTypes(absCode);
    });
  };

  const calculateBalance = (rowData) => {
    const accured = Number(rowData.accured) || 0;
    const taken = Number(rowData.taken) || 0;
    const carryForward = Number(rowData.carryForward) || 0;
    if (rowData.code === 'EL') {
      return accured + carryForward - taken;
    }
    return accured - taken;
  };

  const getMaxAllowedTaken = (rowData) => {
    const accured = Number(rowData.accured) || 0;
    const carryForward = Number(rowData.carryForward) || 0;
    if (rowData.code === 'EL') {
      return accured + carryForward;
    }
    return accured;
  };

  const onRowEditComplete = (e) => {
    let _userLeaveData = [...userLeaveData];
    let { newData, index } = e;
    _userLeaveData[index] = newData;
    let payload = {
      id: _userLeaveData[index].id,
      userId: _userLeaveData[index].userId,
      balance: _userLeaveData[index].balance,
      accured: _userLeaveData[index].accured,
      status: _userLeaveData[index].status,
      taken: _userLeaveData[index].taken,
      carryForward: _userLeaveData[index].carryForward,
    };
    try {
      console.log(payload, "payloadpayloadpayload")
      leaveService.updateUserLeaveBalance(payload).then((resp) => {
        toast.info(resp.data.message);
        getUserLeaves();
      });
    } catch (error) {
      //error
    }
  };

  const takenLeaveEditor = (options) => {
    return (
      <InputNumber
        inputId="takenEditor"
        style={{}}
        mode="decimal"
        minFractionDigits={2}
        maxFractionDigits={2}
        value={options.value}
        onValueChange={(e) => {
          const newTaken = e.value || 0;
          const maxAllowed = getMaxAllowedTaken(options.rowData);
          if (newTaken > maxAllowed) {
            toast.error(
              `Leave taken cannot be more than ${maxAllowed.toFixed(2)}`
            );
            return;
          }
          options.editorCallback(newTaken);
          options.rowData.taken = newTaken;
          options.rowData.balance = calculateBalance(options.rowData);
          setUserLeaveData([...userLeaveData]);
        }}
      />
    );
  };

  const accuredLeaveEditor = (options) => {
    return (
      <InputNumber
        inputId="minmaxfraction"
        style={{}}
        mode="decimal"
        minFractionDigits={2}
        maxFractionDigits={2}
        value={options.value}
        onValueChange={(e) => {
          options.editorCallback(e.value);
          options.rowData.accured = e.value;
          options.rowData.balance = calculateBalance(options.rowData);
          setUserLeaveData([...userLeaveData]);
        }}
      />
    );
  };

  const leaveBalanceEditor = (options) => {
    return (
      <InputNumber
        inputId="minmaxfraction"
        style={{}}
        mode="decimal"
        minFractionDigits={2}
        maxFractionDigits={2}
        value={options.value}
        onValueChange={(e) => options.editorCallback(e.value)}
      />
    );
  };

  const leaveCarryBalanceEditor = (options) => {
    return (
      <InputNumber
        inputId="minmaxfraction"
        style={{}}
        mode="decimal"
        minFractionDigits={2}
        maxFractionDigits={2}
        value={options.value}
        onValueChange={(e) => {
          options.editorCallback(e.value);
          options.rowData.carryForward = e.value;
          options.rowData.balance = calculateBalance(options.rowData);
          setUserLeaveData([...userLeaveData]);
        }}
      />
    );
  };

  const leaveStatusEditor = (options) => {
    const op = [
      { label: "Active", key: 1 },
      { label: "Inactive", key: 0 },
    ];
    return (
      <Dropdown
        inputId="leaveEditor"
        value={options.value}
        options={op}
        onChange={(e) => options.editorCallback(e.value)}
        optionLabel="label"
        optionValue="key"
        placeholder="Select status"
      />
    );
  };

  const addLeave = () => {
    const leaveArray = selectedLeave.map((e) => {
      return {
        userId: clickedUserData.id,
        code: e.code,
        title: e.title,
      };
    });
    try {
      leaveService
        .saveLeavesByUser(leaveArray)
        .then((resp) => {
          toast.success("The leaves have been successfully added to the user.");
          setSelectedLeave([]);
          getUserLeaves();
        })
        .catch((e) => {
          toast.error(e?.response?.data?.error);
        });
    } catch (err) {
      toast.error(err?.response?.data?.error);
    }
    setDlgNewLeave(false);
  };

  const cancelAddition = () => {
    setSelectedLeave([]);
    setDlgNewLeave(false);
  };

  const renderAddNewCode = () => {
    return (
      <Dialog
        header="Confirmation"
        visible={dlgNewLeave}
        onHide={() => setDlgNewLeave(false)}
        style={{ width: "400px" }}
      >
        <div className="mt-2 mb-3">
          <span>Please select a leave new type to add.</span>
          <MultiSelect
            className="mt-2"
            options={leaveTypes}
            optionLabel="label"
            style={{ width: "100%" }}
            placeholder="Select absence code"
            display="chip"
            value={selectedLeave}
            onChange={(e) => setSelectedLeave(e.value)}
            maxSelectedLabels={3}
          />
        </div>
        <div className="mt-2" style={{ textAlign: "right" }}>
          <Button
            label="Add"
            icon="pi pi-plus"
            className="p-button-rounded p-button-primary"
            onClick={addLeave}
          />
          <Button
            label="Cancel"
            className="p-button-rounded p-button-danger ml-2"
            onClick={cancelAddition}
          />
        </div>
      </Dialog>
    );
  };

  return (
    <div className="fields ess-page mt-3">
      <div className="ess-table">
        <DataTable
          className="mt-0"
          responsiveLayout="scroll"
          dataKey="id"
          value={userLeaveData}
          resizableColumns
          columnResizeMode="fit"
          scrollable="horizontal"
          stripedRows
          editMode="row"
          rows={10}
          ref={dt}
          onRowEditComplete={onRowEditComplete}
        // onRowEditInit={(e) => setEditingRowId(e.data.id)}
        // onRowEditCancel={() => setEditingRowId(null)}
        >
          <Column
            field="code"
            header="Leave Types"
            body={(r) => (
              <span>
                <strong>{r.code}</strong> ({r.title})
              </span>
            )}
          />
          <Column
            field="accured"
            header="Accured Leaves"
            style={{ textAlign: "center" }}
            editor={(options) => accuredLeaveEditor(options)}
          />
          <Column
            field="taken"
            header="Leave Taken"
            style={{ textAlign: "center" }}
            editor={(options) => takenLeaveEditor(options)}
          />
          <Column
            field="balance"
            header="Leave Balance"
            style={{ textAlign: "center" }}
            editor={(options) => (
              <InputNumber
                inputId="balanceEditor"
                mode="decimal"
                minFractionDigits={2}
                maxFractionDigits={2}
                value={calculateBalance(options.rowData)}
                onValueChange={(e) => options.editorCallback(e.value)}
                disabled
              />
            )}
          />
          <Column
            field="carryForward"
            header="Carry Forward"
            style={{ textAlign: "center" }}
            editor={(options) => leaveCarryBalanceEditor(options)}
          />
          <Column
            field="status"
            header="Status"
            style={{ textAlign: "center" }}
            body={(r) => (r.status === 1 ? "Active" : "Inactive")}
            editor={(options) => leaveStatusEditor(options)}
          />
          <Column
            header="Action"
            exportable={false}
            rowEditor
            style={{ textAlign: "center" }}
          />
        </DataTable>
      </div>
      <div className="grid" style={{ float: "right" }}>
        <div className="mt-6 ml-6">
          <Button
            label="Assign New"
            icon="pi pi-plus"
            className="p-button-rounded p-button-primary"
            onClick={() => setDlgNewLeave(true)}
          />
          <Button
            label="Cancel"
            className="p-button-rounded p-button-danger ml-2"
            onClick={onCloseMethod}
          />
        </div>
      </div>
      {renderAddNewCode()}
    </div>
  );
};
export default UserLeaveDialog;
